import React from "react";
import "./accountPage.css";

export default function AccountPage({ postcode, savedSchools, onOpenPage, onOpenSchool }) {
  const saved = Array.isArray(savedSchools) ? savedSchools : [];
  const homeLabel = postcode && String(postcode).trim() ? postcode : "Not set";

  return (
    <div className="ac-page">
      <header className="ac-head">
        <p className="ac-kicker">Account</p>
        <h1 className="ac-title">Your home and saved schools</h1>
        <p className="ac-lead">
          Search stays open without signing in. What you save here stays in this browser.
        </p>
      </header>

      <div className="ac-grid">
        <section className="ac-card">
          <h2 className="ac-card-title">Home</h2>
          <p className="ac-postcode">{homeLabel}</p>
          <p className="ac-note">This is the postcode used for catchment and miles.</p>
          <button type="button" className="ac-btn" onClick={() => onOpenPage?.("map")}>
            Open the map
          </button>
        </section>

        <section className="ac-card">
          <h2 className="ac-card-title">Saved schools</h2>
          {saved.length === 0 ? (
            <p className="ac-note">No hearts yet. Save a school from its row on the map.</p>
          ) : (
            <ul className="ac-list">
              {saved.map((school) => (
                <li key={school.id}>
                  <button type="button" className="ac-school" onClick={() => onOpenSchool?.(school)}>
                    <span>{school.name}</span>
                    <span className="ac-meta">{[school.local_authority || school.area, school.gender_type || school.gender].filter(Boolean).join(" · ")}</span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </section>

        <section className="ac-card">
          <h2 className="ac-card-title">Ranking</h2>
          <p className="ac-note">
            GCSE, A level, Ofsted, and distance for the grammar schools, from the same home.
          </p>
          <button type="button" className="ac-btn" onClick={() => onOpenPage?.("ranking")}>
            Open ranking
          </button>
        </section>

        <section className="ac-card">
          <h2 className="ac-card-title">Compare</h2>
          <p className="ac-note">
            Put up to four schools in a row and compare the same published figures from the school file.
          </p>
          <button type="button" className="ac-btn" onClick={() => onOpenPage?.("compare")}>
            Open compare
          </button>
        </section>
      </div>
    </div>
  );
}
